import React from 'react';

/**
 * Input Component - Component input tái sử dụng
 */
interface InputProps {
    label?: string;
    value: string;
    onChange: (value: string) => void;
    type?: 'text' | 'email' | 'password' | 'number' | 'search';
    placeholder?: string;
    disabled?: boolean;
    required?: boolean;
    error?: string;
    className?: string;
    size?: 'small' | 'medium' | 'large';
}

const Input: React.FC<InputProps> = ({
    label,
    value,
    onChange,
    type = 'text',
    placeholder,
    disabled = false,
    required = false,
    error,
    className = '',
    size = 'medium'
}) => {
    const baseClass = 'input';
    const sizeClass = `input-${size}`;
    const errorClass = error ? 'input-error' : '';
    const classes = [baseClass, sizeClass, errorClass, className].filter(Boolean).join(' ');

    return (
        <div className="input-group">
            {label && (
                <label className="input-label">
                    {label}
                    {required && <span className="required">*</span>}
                </label>
            )}
            <input
                type={type}
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                disabled={disabled}
                required={required}
                className={classes}
            />
            {error && <span className="error-message">{error}</span>}
        </div>
    );
};

export default Input;
